/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-async-promise-executor */
// NOTE: 'syncEditAnimals' is for storing offline submitted pending editAnimals to sync with back end
// when get online but 'editAnimals' is for storing an offline list of editAnimals to show when offline
import connector from '../connector';

const addEditAnimal = (editAnimal) => new Promise(async (resolve, reject) => {
    try {
        const userId = localStorage.getItem('userId');
        if (userId) {
            const db = await connector();
            const transaction = db.transaction('syncEditAnimals', 'readwrite');
            const syncEditAnimalsStore = transaction.objectStore('syncEditAnimals');

            const offlineId = Date.now();
            const editAnimalToSave = {
                userId,
                offlineId,
                ...editAnimal
            }

            syncEditAnimalsStore.add(editAnimalToSave);
            transaction.oncomplete = () => {
                db.close();
                resolve({ success: true, offlineId });
            };
        }
        else {
            reject({ success: false, error: 'Error: User not found!' });
        }
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getEditAnimalsList = () => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('syncEditAnimals', 'readonly');
        const syncEditAnimalsStore = transaction.objectStore('syncEditAnimals');

        const allEditAnimals = syncEditAnimalsStore.getAll();

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: allEditAnimals.result });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getEditAnimalByOfflineId = (offlineId) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('syncEditAnimals', 'readonly');
        const syncEditAnimalsStore = transaction.objectStore('syncEditAnimals');

        const editAnimal = syncEditAnimalsStore.get(offlineId);

        transaction.oncomplete = () => {
            db.close();
            if (editAnimal && editAnimal.result) {
                resolve({ success: true, editAnimal: editAnimal.result });
            }
            else {
                reject({ success: false, error: 404 });
            }
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const deleteEditAnimal = (offlineId) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('syncEditAnimals', 'readwrite');
        const syncEditAnimalsStore = transaction.objectStore('syncEditAnimals');

        syncEditAnimalsStore.delete(offlineId);

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});


const syncEditAnimals = {
    addEditAnimal,
    getEditAnimalsList,
    getEditAnimalByOfflineId,
    deleteEditAnimal
}

export default syncEditAnimals;
